import { render } from "./Dbg.vue?vue&type=template&id=a65942fe&scoped=true"
const script = {}

import "./Dbg.vue?vue&type=style&index=0&id=a65942fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65942fe"]])

export default __exports__